import { Tag } from 'antd'

const AntTagStyled = Tag
export default AntTagStyled
